/* eslint-disable no-array-constructor */
import React, { Component } from 'react'
import { Form, Button, Input } from "antd"
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import "./Dataset.scss"
let num = 0;

const parmsCss = {
    margin: "3px 0px 21px 0px",
    width: "189px",
    float: "left"
},
    layout = {
        labelCol: {
            span: 4,
        },
        wrapperCol: {
            span: 19,
        },
    }

export default class Dataset extends Component {
    state = {
        fromArr: [num],		//添加parmas的配置项
        yanzhengma: null
    }
    componentDidMount() {
    }
    onFinish = values => {
        let team = null,
            str  = "",
            arr  = [];
        for( let key in values ){
            console.log(key)
            if(key === "team")
                team = values[key]
            if(key.indexOf("name")>=0 ){
                arr[key[key.length-1]] = `成员:` + values[key]
            }
            if(key.indexOf("email")>=0){
                arr[key[key.length-1]] += `---邮箱:` + values[key]
            }
        }
        str = "团队:" + team + ", \n" + arr.join(', <br/>')
        console.log(str)
        let params = {
            to: 'jingyuan.cjy@alibaba-inc.com',
            subject: '邮箱标题',
            body: str
        };
        
        window.open(`mailto:${params.to}?subject=${params.subject}&body=${params.body}`, '_parent');
    }
    addParmsfrom = () => {
        this.setState({
            fromArr: this.state.fromArr.concat(++num)
        })
    }
    // 删除参数表单项
    deleteParmasFrom(index) {
        this.setState({
            fromArr: this.state.fromArr.filter((_, i) => i !== index)
        })
    }
    render() {
        const { fromArr } = this.state
        return (
            <div className="sign-up">
                <h2> Welcome to the competition</h2>
                <p> To obtain the dataset, please send your team information to us. </p>
                <Form
                    {...layout}
                    hideRequiredMark
                    colon={false}   //label的冒号
                    ref={this.formRef}
                    name="rule-ref"
                    onFinish={this.onFinish}
                    style={{ width: "500px", margin: "0 auto" }}
                >
                    <Form.Item
                        name="team"
                        rules={[
                            {
                                label: `team name`,
                                required: true,
                            },
                        ]}
                    >
                        <Input placeholder="team name" style={{ width: "340px" }} />
                    </Form.Item>
                    <div style={{ overflow: "hidden" }}>
                        {
                            fromArr.map((Item, index) =>
                                <div style={{ overflow: "hidden", height: "39px" }} key={Item}>
                                    <Form.Item
                                        name={`name${Item}`}
                                        style={parmsCss}
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Input placeholder="member name" />
                                    </Form.Item>
                                    <Form.Item
                                        name={`email${Item}`}
                                        style={parmsCss}
                                        rules={[
                                            {
                                                type: "email",
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Input placeholder="e-mail" />
                                    </Form.Item>
                                    {
                                        index > 0
                                            ? <MinusCircleOutlined
                                                style={{ marginTop: "12px" }}
                                                onClick={this.deleteParmasFrom.bind(this, index)}
                                            />
                                            : null
                                    }
                                </div>
                            )
                        }
                    </div>
                    <div className="addParamsButton">
                        <Button
                            style={{ color: "#8C8C8C", border: "1px dashed #ff6a00", width: '340px', margin: "27px 0 0 0px", display: "block" }}
                            onClick={this.addParmsfrom}
                            type="dashed"
                        >
                            <PlusOutlined />
							address add a member
						</Button>
                    </div>
                    <Form.Item>
                        <Button type="primary" style={{marginTop:"24px"}} htmlType="submit">
                            apply
                        </Button>
                    </Form.Item>
                </Form >
            </div>
        )
    }
}